/** Every `contract-contacts` query for one contract — what the drawer
 * invalidates after a save, so any list rendered off it refetches. */
export const contractContactsQueryKey = (contractId: string | number) =>
  ["contract-contacts", String(contractId)] as const;

/** The single occupant the drawer is editing. Nested under the contract's key
 * so invalidating the contract's contacts covers it too. */
export const occupantQueryKey = (contractId: string | number, contactId: string) =>
  [...contractContactsQueryKey(contractId), "occupant", contactId] as const;
